import '../svg-icon/svg-icon';

import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

export interface Option {
    label: string;
    value: string | number;
}

export interface OptionGroups {
    [key: string]: Option[];
}

@customElement('filter-input')
export class FilterInput extends LitElement {

    // Props

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    property: string = '';

    @property({ type: Object })
    options: OptionGroups = {};

    @property({ type: Boolean, reflect: true })
    expanded: boolean = false;
    
    @property({ type: Boolean, reflect: true })
    disabled: boolean = false;

    @property({ type: Object })
    selectedOption: Option|null = null;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('FilterInput');
    }

    firstUpdated() {
		const hasOptions =
			Object.keys(this.options).length
			&& Object.values(this.options).every((opts) => opts.length)
        if (!hasOptions) this.disabled = true;
    }

    // Render
    
    render() {
        const classes = {
            'is-active': this.selectedOption !== null,
        };
        return html`
            <div class="FilterInput-display ${ classMap(classes) }" 
                ?disabled="${ this.disabled }"
                @click="${ () => this._toggle() }">
				<button class="FilterInput-displayContainer"
					aria-expanded="${ this.expanded }">
					<div class="FilterInput-value">
						${ this.selectedOption?.label || this.name }
					</div>
					${ this.expandButtonTemplate() }
				</button>
                ${ this.selectedOption ? this.removeButtonTemplate() : '' }
			</div>
            ${ (this.expanded && Object.keys(this.options).length) ? this.bodyTemplate() : '' }
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

	bodyTemplate(): TemplateResult {
		return html`
			<div class="FilterInput-bodyWrapper">
				<div class="FilterInput-body">
					${ (Object.keys(this.options).length == 1) 
						? this.optionListTemplate(this.options[Object.keys(this.options)[0]])
						: Object.keys(this.options).map((label) => this.optionGroupTemplate(label, this.options[label])) }
				</div>
			</div>
		`;
	}

    optionListTemplate(options: Option[]): TemplateResult {
        return html`
            <ul class="FilterInput-optionList">
                ${ options.map((option) => this.optionTemplate(option))}
            </ul>
        `;
    }

	optionGroupTemplate(label: string, options: Option[]): TemplateResult {
		return html`
			<details class="FilterInput-details">
				<summary class="FilterInput-summary">
					${ label }
				</summary>
				<div>
					${ this.optionListTemplate(options) }
				</div>
			</details>
		`;
	}

    optionTemplate(option: Option): TemplateResult {
        const classes = {
            'is-active': JSON.stringify(option) == JSON.stringify(this.selectedOption),
        };
        return html`
            <li class="FilterInput-option ${ classMap(classes) }"
                @click="${ () => this._toggle(option) }">
                ${ option.label }
            </li>
        `;
    }

    removeButtonTemplate(): TemplateResult {
        return html`
            <button class="FilterInput-button FilterInput-button--close" @click="${ this._reset }">
                <svg-icon name="close"></svg-icon>
            </button>
        `;
    }

    expandButtonTemplate(): TemplateResult {
        return html`
            <div class="FilterInput-button FilterInput-button--select">
                ${ (this.expanded)
                    ? html`<svg-icon name="upCaret"></svg-icon>`
                    : html`<svg-icon name="downCaret"></svg-icon>` }
            </div>
        `;
    }

    // Getters

    get _value() {
        return this.selectedOption?.value;
    }

    // Methods

    private _toggle(option: Option | null = null) {
		console.log('toggle');
		console.log(this.options);
        if (Object.keys(this.options).length) {
            this.expanded = !this.expanded;
        }
        if (option) {
            this.selectedOption = option;
            const event = new Event('change');
            this.dispatchEvent(event);
        }
    }

    private _reset(e: Event) {
        e.stopPropagation();
        this.selectedOption = null;
        this.expanded = false;
        const event = new Event('change');
        this.dispatchEvent(event);
    }

}